// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__fSGoY","avatar":"style_avatar__30nvZ","menuIcon":"style_menuIcon__imH0O"};